import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { OnboardingEffects } from './direct-onboarding.effects';
import { onboardingReducer } from './direct-onboarding.reducer';

@NgModule({
  imports: [StoreModule.forFeature('onboarding', onboardingReducer), EffectsModule.forFeature([OnboardingEffects])],
})
export class UIOnboardingStoreModule {}
